import { ISelectItem } from "winfakt-vue-components";
import * as services from "@/services";
import { ModalService } from "@/services/modal-service";

export enum ExtraButtonLocation{
	TICKETS = 0
}


export function getExtraButtonLocationAsSelectItems():ISelectItem<ExtraButtonLocation>[]{
	let offset = Object.values(ExtraButtonLocation).length / 2;
	return Object.values(ExtraButtonLocation).filter(f=>typeof(f)=="string").map((v,i)=>{
		return {
			text: v,
			value: Object.values(ExtraButtonLocation)[i+offset] as any as ExtraButtonLocation
		};
	});
}

export class ExtraButton {
	ID:number = 0;
	Location:ExtraButtonLocation = ExtraButtonLocation.TICKETS;
	Label:string = "Nieuwe knop";
	Icon:string = "cog";
	Code:string = "return \"https://winfakt.app\""
	OpenInModal:boolean = false;
	PaddedModal:boolean = false;
	Width:number = 0;
	Height:number = 0;

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID;
		this.Location = data.Location;
		this.Label = data.Label;
		this.Icon = data.Icon;
		this.Code = data.Code;
		this.OpenInModal = data.OpenInModal;
		this.PaddedModal = data.PaddedModal;
		this.Width = data.Width;
		this.Height = data.Height;
	}

	public getJSON(){
		return {
			ID: this.ID,
			Location: this.Location,
			Label: this.Label,
			Icon: this.Icon,
			Code: this.Code,
			OpenInModal: this.OpenInModal,
			PaddedModal: this.PaddedModal,
			Width: this.Width,
			Height: this.Height
		};
	}


	toSelectItem(data:any):ISelectItem<Function>{
		let AsyncFunctionConstructor:any = new Function("return (async function(){}).constructor;")();
		let func = new AsyncFunctionConstructor("services", "data", this.Code) as Function;
		let value = async ()=>{
			let url = await func(services);
			window.open(url);
		};
		if (this.OpenInModal) {
			value = async ()=>{
				let url = await func(services, data);
				ModalService.openIframeModal(url, this.Label, {padded: this.PaddedModal, width: this.Width, height: this.Height});
			};
		}
		return {
			text: this.Label,
			icon: this.Icon,
			value
		};
	}
}